// Globally register all directives for convenience, by their file name.
import Vue from 'vue'
import { eachInContext } from '@evolve/helpers/RequireHelper'

eachInContext(require.context('./directives'), Vue.directive.bind(Vue))
